import { useEffect, useState } from 'react';
import { MerChantModel } from '../../../models/merChantModel';
import axios from '../../../lib/axios';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { numberFormat } from '../../../utils/nunberFormat';
import { StatusEnum } from '../../../enums/status';
import { MERCHANT_STORE_DELETE, MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchant';
import { MerchantEnum } from '../../../enums/merchantEnum';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

export const useBranchManageControllers = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>('');
  const [data, setData] = useState<MerChantModel[]>([]);

  const [tabStatus, setTabStatus] = useState<StatusEnum>(StatusEnum.ALL);
  const [merchantType, setMerchantType] = useState<MerchantEnum>(MerchantEnum.Jiffy);
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [loadingDeleteButton, setLoadingDeleteButton] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>(null!);
  const [selectedMerchant, setSelectedMerchant] = useState<MerChantModel>(null!);

  const adminRole = useSelector((state: RootState) => state?.auth?.data?.role?.role_type);
  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);

  const { t } = useTranslation('global');

  const TableHeader: string[] = [
    t('No.'),
    t('Image'),
    t('name'),
    t('Merchant No'),
    t('Province'),
    t('District'),
    t('Village'),
    t('Phone'),
    t('Active'),
  ];

  const handleSelectedBranch = (e: any) => {
    setMerchantType(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchValue = (e: any) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, id: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(id);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleOpenDeleteForm = () => {
    setOpenDeleteForm(true);
  };
  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleOpenEditForm = () => {
    setOpenForm(true);
    const getData: MerChantModel = data.filter((item) => item.id === selectedId)[0];
    setSelectedMerchant(getData);
  };

  const filterDataByStatus: MerChantModel[] = data?.filter((item: MerChantModel) => {
    if (tabStatus === StatusEnum.ALL) {
      return true;
    } else if (tabStatus === StatusEnum.ACTIVE) {
      return item.isActive === true;
    } else if (tabStatus === StatusEnum.INACTIVE) {
      return item.isActive === false;
    } else {
      return false;
    }
  });

  const filterDataByMerchantType: MerChantModel[] = filterDataByStatus.filter(
    (data: MerChantModel) => {
      if (merchantType === MerchantEnum.Jiffy) {
        return data?.company === MerchantEnum.Jiffy;
      } else if (merchantType === MerchantEnum.SkyMark) {
        return data?.company === MerchantEnum.SkyMark;
      } else {
        return false;
      }
    }
  );
  const countMerchant = filterDataByMerchantType?.length;

  const filterData: MerChantModel[] = filterDataByMerchantType?.filter(
    (item: MerChantModel) =>
      item?.nameEn?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.nameLa?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.provice?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.village?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.company?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item?.merchantNo?.toLowerCase().includes(searchValue.toLowerCase())
  );

  const rows: MerChantModel[] = filterData?.slice((currentPage - 1) * 10, currentPage * 10);

  const isSearchNotFound: boolean = !filterData.length && !!searchValue;
  const countPagination = Math.ceil(filterDataByMerchantType.length / 10);

  const filterActive = filterDataByMerchantType.filter((item) => (item.isActive ? true : false));
  const filterInActive = filterDataByMerchantType.filter((item) => (item.isActive ? false : true));

  const handleDelete = async () => {
    try {
      setLoadingDeleteButton(true);
      await axios.delete(MERCHANT_STORE_DELETE + selectedId);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingDeleteButton(false);
      setOpenDeleteForm(false);
      setOpenMenu(null);
    }
    handleFetchMerChant();
  };

  const handleFetchMerChant = async () => {
    try {
      setLoadingData(true);
      const branchResponse = await axios.get(MERCHANT_STORE_FIND_MANY);

      if (branchResponse.data?.length > 0) {
        const matchingMerchants = branchResponse.data.filter((merchant: any) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );
        if (adminRole === 'SUPER_ADMIN') {
          setData(branchResponse?.data);
        } else if (adminRole === 'ADMIN') {
          setData(matchingMerchants);
        }
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    handleFetchMerChant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    openMenu,
    openForm,
    handleOpenForm,
    handleCloseForm,
    handleOpenMenu,
    handleCloseMenu,
    rows,
    filterData,
    data,
    handleSearchValue,
    searchValue,
    isSearchNotFound,
    TableHeader,
    countPagination,
    handlePageChange: (event: any, newPage: any) => setCurrentPage(newPage),
    currentPage,
    filterActive,
    filterInActive,
    handleFetchMerChant,
    handleDelete,
    loadingDeleteButton,
    handleOpenDeleteForm,
    openDeleteForm,
    handleCloseDeleteForm,
    handleOpenEditForm,
    selectedMerchant,
    selectMerchant: (newValue: MerChantModel) => setSelectedMerchant(newValue),
    handleSetTabStatus: (newValue: StatusEnum) => {
      setCurrentPage(1);
      setTabStatus(newValue);
    },
    tabStatus,
    handleCountIndex: (index: number) =>
      numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (currentPage - 1)),
    loadingData,
    merchantType,
    handleSelectedBranch,
    filterDataByMerchantType,
    countMerchant
  };
};
